import api from './api.js';

// ==================== TEAM CHAT APIS ====================

export const chatAPI = {
    // List other admins available to chat with
    getContacts: (search) => api.get('/api/chat/contacts', { params: search ? { search } : {} }),

    // List my conversations (with last message + unread counts)
    getConversations: () => api.get('/api/chat/conversations'),

    // Open or create a 1-to-1 conversation with another admin
    openConversation: (participantId) => api.post('/api/chat/conversations', { participantId }),

    // Message history for a conversation
    getMessages: (conversationId, params) =>
        api.get(`/api/chat/conversations/${conversationId}/messages`, { params }),

    // Send a message in a conversation
    sendMessage: (conversationId, text) =>
        api.post(`/api/chat/conversations/${conversationId}/messages`, { text }),

    // Mark a conversation as read
    markRead: (conversationId) =>
        api.post(`/api/chat/conversations/${conversationId}/read`),
};

export default chatAPI;
